import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetailsQueries } from '../../queries/details.queries';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AnalyticsService, fromMatchMedia } from 'smartauction-frontend-micro-library';
import { ImageMetaData, DetailsState } from 'remarketing-angular-library';
import { Select, Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { InventoryItemDataService } from '../../../sell-shared/services/inventory-item-data.service';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SellerLocationComponent } from '../seller-location/seller-location.component';
import { SellerUpdateComponent } from '../seller-update/seller-update.component';
import { ConditionDisclosuresComponent } from '../condition-disclosures/condition-disclosures.component';
import { EquipmentAccessoriesComponent } from '../equipment-accessories/equipment-accessories.component';
import { BookValueComponent } from '../book-value/book-value.component';
import { VehicleDetailComponent } from '../vehicle-detail/vehicle-detail.component';
import { AuctionDetailComponent } from '../auction-detail/auction-detail.component';
import { DetailsHeaderComponent } from '../details-header/details-header.component';
import { VdpLoaderComponent, GridCarouselToggleComponent, CarouselComponent, ImageGridComponent } from 'remarketing-ui-components-lib';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'lib-details-shell',
    templateUrl: './details-shell.component.html',
    styleUrls: ['./details-shell.component.scss'],
    imports: [TranslocoDirective, VdpLoaderComponent, DetailsHeaderComponent, GridCarouselToggleComponent, CarouselComponent, ImageGridComponent, AuctionDetailComponent, VehicleDetailComponent, BookValueComponent, EquipmentAccessoriesComponent, ConditionDisclosuresComponent, SellerUpdateComponent, SellerLocationComponent, AccordionModule, AsyncPipe]
})
export class DetailsShellComponent implements OnInit, OnDestroy {
  @Select(DetailsQueries.images) images$: Observable<ImageMetaData[]>;
  isDesktop$ = fromMatchMedia('(min-width: 992px)');

  /**
   * Adobe Analytics overwrite jQuery and our plugins === borked slider.
   */
  slickAvailable = false;
  detailsState$ = new BehaviorSubject<'loading' | 'loaded' | 'error'>('loading');
  showImageGrid = false;

  destroyed$ = new Subject();
  carouselData: any;
  gridCarouselData: any;
  imageGridTranslations: any;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private analyticsService: AnalyticsService,
    private readonly inventoryItemDataService: InventoryItemDataService,
    private readonly translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.translocoService.selectTranslateObject('UIComponents').subscribe(translatedObj => {
      this.carouselData = translatedObj.carousel;
      this.gridCarouselData = translatedObj.gridcarouselToggle;
      this.imageGridTranslations = translatedObj.imageGrid;
    });
    this.store.select(DetailsState.detailsState).subscribe(state => {
      if (state.loading) {
        this.detailsState$.next('loading');
      } else {
        this.detailsState$.next('loaded');
      }
    });

    this.inventoryItemDataService.fetchCompleteDetails();

    try {
      this.slickAvailable = typeof (window as any).jQuery.fn.slick !== 'undefined';
    } catch (e) {
      this.slickAvailable = false;
    }

    setTimeout(() => {
      this.analyticsService.trackPageLoad({
        page: {
          pageName: `${this.analyticsService.digitalData.page.category.site}:Sell:Manage:Details`,
          section: 'Sell',
          site: this.analyticsService.digitalData.page.category.site,
          subsection: 'Manage',
          title: 'Details',
          data: {
            vehicleList: this.route.snapshot ? this.route.snapshot.parent.paramMap.get('inventoryItemUuid') : ''
          }
        }
      });
    }, 200);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
